import type { OrderDetailResponseDto } from "Infrastructure/Api/Api";
import { useDateFormat } from "Infrastructure/Utilities/dateFormat";
import { CalendarMonth } from "@mui/icons-material";
import { OrderInfoCard, type OrderInfoItem } from "./OrderInfoCard";

type DatesCardProps = {
	order?: OrderDetailResponseDto;
};

export function DatesCard({ order }: DatesCardProps) {
	const { formatDate } = useDateFormat();

	if (!order) return null;

	const items: OrderInfoItem[] = [
		{
			icon: <CalendarMonth fontSize="small" />,
			value: order.dateNextAction
				? formatDate(order.dateNextAction)
				: undefined,
			label: "Next",
			show: !!order.dateNextAction,
		},
		{
			icon: <CalendarMonth fontSize="small" />,
			value: order.dateStarting ? formatDate(order.dateStarting) : undefined,
			label: "Starting",
			show: !!order.dateStarting,
		},
		{
			icon: <CalendarMonth fontSize="small" />,
			value: order.dateDone ? formatDate(order.dateDone) : undefined,
			label: "Done",
			show: !!order.dateDone,
		},
	];
	return <OrderInfoCard title="Dates" items={items} />;
}
